export default "__VITE_ASSET__f77e47d7__"